import { useEffect } from "react";
import { useLockStore } from "../../store/lockStore";

/**
 * 1s tick effect against `countdownSeconds`. Purely cosmetic — server-side
 * auto-grant fires independently of the local timer. The hook is dependency-
 * free at the parameter level and reads / writes the store directly so the
 * tick doesn't get torn down and re-created every time the store updates.
 */
export function useLockCountdown(): void {
  const countdownSeconds = useLockStore((s) => s.countdownSeconds);
  const setCountdown = useLockStore((s) => s.setCountdown);

  useEffect(() => {
    if (countdownSeconds === null || countdownSeconds <= 0) return;
    const id = window.setInterval(() => {
      const current = useLockStore.getState().countdownSeconds;
      if (current === null || current <= 0) return;
      setCountdown(Math.max(0, current - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [countdownSeconds, setCountdown]);
}
